import React from 'react';
import { Tooltip, tooltipClasses } from '@mui/material';
import styled from '@emotion/styled';
import { greyColor7, whiteColor } from '../../configs/styles/muiThemes'; // Ensure these colors are correctly imported

// Custom-styled Tooltip
const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: whiteColor, // Custom background color
    color: "rgba(0, 0, 0, 0.87)", // Tooltip text color
    boxShadow: "0 3px 4px rgb(229 233 240 / 22%)", // Light shadow for the tooltip
    border: `1px solid ${greyColor7}`, // Border color
    fontSize: 11, // Font size in px
  },
}));

const LightToolTip = (props) => {
  return (
    <LightTooltip {...props}>
      {props.children} {/* Render the wrapped children */}
    </LightTooltip>
  );
};

export default LightToolTip;
